// extracted by mini-css-extract-plugin
export default {"imgContainer":"West_imgContainer__BRx1f","text":"West_text__xHDsZ"};